import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatTableModule } from '@angular/material/table';
import { RegistrosInterface } from './registros-interface';
import { ChipComponent } from '../chip/chip.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { DetalleRegistroComponent } from 'app/modules/admin/registros/detalle-registro/detalle-registro.component';
import { environment as env } from 'enviroments/environment';
import { ControlAccesoDirective } from 'app/shared/directives/control-acceso.directive';

@Component({
    selector: 'app-tabla-registros',
    templateUrl: 'tabla-registros.component.html',
    standalone: true,
    imports: [CommonModule, MatTableModule, ChipComponent, MatMenuModule, MatIconModule, MatDialogModule, ControlAccesoDirective]
})

export class TablaRegistrosComponent implements OnInit {
    private readonly allColumns: string[] = [
        'codigo',
        'area',
        'subarea',
        'ciclo',
        'tipoProfesional',
        'carrera',
        'estatus',
        'details'
    ];

    @Input() registros: RegistrosInterface[] = [];
    @Input() set esBasico(value: boolean) {
        this._esBasico = value;
        this.displayedColumns = value
            ? this.allColumns.filter((column) => column !== 'subarea')
            : [...this.allColumns];
    }
    get esBasico(): boolean {
        return this._esBasico;
    }
    @Output() eliminarRegistro = new EventEmitter<RegistrosInterface>();
    @Output() publicarRegistro = new EventEmitter<RegistrosInterface>();

    TIPOLOGIA_ID_CARRERA_PUBLICADA = env.TIPOLOGIA_ID_CARRERA_PUBLICADA;

    constructor(
        private _dialog: MatDialog
    ) { }

    displayedColumns: string[] = [...this.allColumns];
    private _esBasico = false;

    ngOnInit() { }

    openDetails(registro: RegistrosInterface) {

        this._dialog.open(DetalleRegistroComponent, {
            width: '75%',
            data: registro
        })

    }

    onEliminarRegistro(registro: RegistrosInterface): void {
        this.eliminarRegistro.emit(registro);
    }

    onPublishRegistro(registro:RegistrosInterface): void {
        this.publicarRegistro.emit(registro)
    }
}
